var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"skeleton-holder"},[(_vm.isLoading)?_c('table',{staticClass:"skeleton-table",attrs:{"border":"0"}},_vm._l((_vm.numberOfRow),function(num){return _c('tr',{key:num},[_vm._m(0,true)])}),0):_c('span',[_vm._v("Keine Verknüpfung vorhanden")])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('td',[_c('div')])
}]

export { render, staticRenderFns }